import { put, take, fork, call, select } from "redux-saga/effects";
import {
  enableScopeLoading,
  disableScopeLoading,
} from "../scope-loading/actions";
import { ScopeErrorAction } from "../scope-error/types";
import { ClaimAction, ClaimScope } from "./types";
import { cleanUpClaim, setClaimRecord } from "./actions";
import * as API from "../../service/api";
import { mapApiClaim } from "./helper";
import { RootState } from "../root-reducer";
import * as Api from "../../service/api";

function* fetchClaimRecords(): Generator<any, void, any> {
  while (true) {
    const { payload = "" } = yield take(ClaimAction.GET_CLAIM_RECORD);
    yield put(enableScopeLoading(ClaimScope));
    try {
      if (!payload) throw new Error("Id is required");
      yield put(cleanUpClaim());
      const data = yield call(API.claim.getClaimById, payload);
      yield put(setClaimRecord(mapApiClaim(data)));
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: ClaimScope,
        error,
      });
    } finally {
      yield put(disableScopeLoading(ClaimScope));
    }
  }
}

function* sendEmailFlow() {
  while (true) {
    const { payload, callBack } = yield take(ClaimAction.SEND_EMAIL);
    yield put(enableScopeLoading(`contact-${ClaimScope}`));
    try {
      const claimId = yield select((state: RootState) => state?.claim?.id);
      if (!claimId) throw new Error("Claim Id not found.");
      let { data = {} } = payload;
      let { toEmail = [] } = data;
      if (!(toEmail.length > 0)) {
        throw new Error("Customer Emails not found.");
      }
      const response = yield call(API.claim.sendEmail, claimId, toEmail);
      const res = response?.result?.data[0]?.details;
      if (res.message_id) {
        callBack();
      }
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: `contact-${ClaimScope}`,
        error,
      });
    } finally {
      yield put(disableScopeLoading(`contact-${ClaimScope}`));
    }
  }
}

function* submitClaimTicketFlow() {
  while (true) {
    const { payload, callBack } = yield take(ClaimAction.SUBMIT_TICKET);
    yield put(enableScopeLoading(`contact-${ClaimScope}`));
    try {
      const {
        dealerName = "N/A",
        claimNumber = "N/A",
        customerName = "N/A",
        email: customerEmail = "N/A",
        phoneNumber: customerPhone = "N/A",
      } = yield select((state: RootState) => state?.claim);

      const userEmail = yield select((state: RootState) => state?.user?.email);

      let { data = {} } = payload;
      let { comment = {}, reason = {} } = data;

      const res = yield call(Api.deskTicket.contactTicket, {
        subject: `Dealer: ${dealerName} Claim: ${claimNumber}`,
        description: `
        Customer Name: ${customerName}
        <br>
        Customer Email: ${customerEmail}
        <br>
        Customer Phone: ${customerPhone}
        <br>
        Reason: ${reason}
        <br>
        Message: 
        <br>
        ${comment.replace(/\n/g, "<br>")}
        `,
        contact_email: userEmail || "no@email.com",
      });
      if (res.id) {
        callBack();
      }
    } catch (error) {
      yield put({
        type: ScopeErrorAction.SET_SCOPE_ERROR,
        payload: `contact-${ClaimScope}`,
        error,
      });
    } finally {
      yield put(disableScopeLoading(`contact-${ClaimScope}`));
    }
  }
}

export default function* claimSaga(): Generator<any, void, any> {
  yield fork(fetchClaimRecords);
  yield fork(submitClaimTicketFlow);
  yield fork(sendEmailFlow);
}
